const CRM_TRACKING_PARAMS = ['akid', 'email_referrer', 'token', 't']

export default {
  methods: {
    urlToShareWithTracking() {
      // Take the current URL, add tracking parameters to it, and return it.

      // First, get the parameters out of the current URL.
      let url = new URL(window.location.href)
      let params = new URLSearchParams(url.search)

      // Strip out CRM tracking parameters that may be personally identifying.
      CRM_TRACKING_PARAMS.map((p) => params.delete(p))

      // Set utm_medium and utm_source, replacing any previous values
      if (this.utmMedium) {
        params.set('utm_medium', this.utmMedium)
      }
      params.set('utm_source', this.utmSource)

      // Convert the modified parameters back into a URL string and return it.
      url.search = params.toString()
      return url.toString()
    }
  }
}
